import _ from 'lodash';
import React from 'react';
import { inject } from 'mobx-react';
import autobind from 'autobind-decorator';

import { NavLink } from 'react-router-dom';

import DeleteButton from 'common/components/delete-button';
import PlaylistModal from 'common/components/playlist-modal';

@inject('songsStore', 'artistStore', 'playlistStore')
class MZDListItem extends React.Component {
	render () {
		const { songsStore, artistStore, playlist, returnURL } = this.props;
		const { _id, title } = playlist;

		return (
			<div
				className="grid-x grid-padding-x"
				data-ta={ `hfmPickItem${playlist._id}` }
			>
					<div className="cell small-12 grid-x padding-1">
					<div className="cell small-8">
							<i className={`fas fa-${playlist.listType == "SONGS" ? 'music' : playlist.listType == "ALBUM" ? 'album' : playlist.listType == "ARTIST" ? 'user-music' : 'broadcast-tower'} margin-right-1`}></i>
							{ playlist.title }
								</div>
								<div className="cell small-4 text-left grid-x" style={{justifyContent: 'flex-end'}}>
									<NavLink
										to={{ 
											pathname: `/list-editor/` + playlist._id,
											data: {
												listType: playlist.listType, 
												listId: playlist._id,
												playlist: this.getPlaylistByID(playlist._id),
												returnURL: returnURL 
											}
										}}
									>
										<i className={`fas fa-pencil`} />
									</NavLink>
									<DeleteButton
										orientation="up"
										warningText={ `Really remove ${ playlist.title }?` }
										onConfirmClick={ this.onConfirmClick }
									>
										<button
											className="button alert clear margin-0 padding-right-0 padding-top-0"
											data-ta="listItemDeleteBtn"
										>
											<span className="fas fa-trash margin-0"></span>
										</button>
									</DeleteButton>
							</div>
					</div>				
			</div>
		);
	}

	@autobind
	onConfirmClick () {
		const { playlistStore, playlist } = this.props;
		playlistStore.deleteItem(playlist);
	}

	getPlaylistByID (_id) {
		const { playlistStore } = this.props;
		return playlistStore.getPlaylistByID(_id);
	}
}

export default MZDListItem;
